export const ARIA_VALUETEXT_ATTRIBUTE = "aria-valuetext";
export const BUTTON = "button";
export const CANCEL_BUTTON = "cancelButton";
export const REMOVE_BUTTON = "removeButton";
export const CANCEL = "cancel";
export const PERCENTAGE_ANNOUNCEMENTS = [0, 26, 51, 76, 87, 100];
export const PROGRESSBAR_ANNOUNCEMENT_DELAY = 0;
export const PROGRESSBAR_CLEAR_ANNOUNCEMENT_DELAY = 500;